import DecommissionStatus from "~/models/enums/DecommissionStatus.enum";

export const primaryButtonDisabledClasses = (disabled: boolean) => `
  top-[100px] 
  left-[120px] 
  p-2 
  px-4 
  gap-2 
  rounded-tl-[2px] 
  rounded-tr-none 
  rounded-br-none 
  rounded-bl-none
  opacity-[0.45] 
  ${disabled ? 'cursor-not-allowed' : ''}
`;

export const primaryButtonClasses = (disabled:boolean) => `
  bg-Foundation/Primary
  border 
  border-[#FFFFFF] 
  focus:border-2 
  focus:border-white 
  focus:shadow-[0_0_0_2px_#B60F8D]
  hover:bg-Foundation/Primary-Dark
  active:bg-Foundation/Primary-Darker
"w-[82px] h-[40px] rounded-md border border-[#752764] bg-[#B60F8D] opacity-100 gap-2 pt-[4px] pr-[16px] pb-[4px] pl-[16px] text-sm
  ${disabled ? 'opacity-45 cursor-not-allowed' : ''}
`;

export const buttonSecondaryClasses = (disabled:boolean) => `
  bg-white 
  border-2 
  border-Primary
  text-Primary 
  hover:bg-Foundation/Secondary-Extra-light
  active:bg-[#B60F8D] 
  focus:outline-none 
  focus:ring-2 
  focus:ring-Neutral/White
  focus:shadow-[0_0_0_2px_#002B6E]
 "w-[82px] h-[40px] rounded-md border border-[#ACACAC] bg-[#F5F5F5] opacity-100 gap-2 pt-[4px] pr-[16px] pb-[4px] pl-[16px] text-sm
  ${disabled ? 'opacity-45 cursor-not-allowed' : ''}
`;

export const buttonLinkClasses = (disabled:boolean) => `
  focus:border-[#FFFFFF] 
  focus:outline-none 
  focus:ring-2 
  focus:ring-Primary
  hover:bg-primary-extra-light
  hover:text-Primary
  active:bg-[#A0C0FA] 
  active:text-primary-dark 
  "w-[82px] h-[40px] rounded-md border border-transparent bg-primary-extra-light opacity-100 gap-2 pt-[4px] pr-[16px] pb-[4px] pl-[16px] text-sm
  ${disabled ? 'opacity-45 cursor-not-allowed' : ''}
`;

export const buttonDangerClasses = (disabled:boolean) => `
  bg-[#CA3532] 
  text-white 
  opacity-100 
  hover:bg-on-error-container
  active:bg-[#290909] 
  focus:border-2 
  focus:border-white 
  focus:shadow-[0_0_0_2px_#031636]
  "w-[82px] h-[40px] rounded-md border border-white bg-[#CA3532] opacity-100 gap-2 pt-[4px] pr-[16px] pb-[4px] pl-[16px] text-sm whitespace-nowrap
  ${disabled ? 'opacity-45 cursor-not-allowed' : ''}
`;


export const labelPrimaryClasses = `
  font-arial 
  text-[16px] 
  font-normal 
  leading-[28px] 
  text-center 
  text-[#FFFFFF] 
  whitespace-nowrap
`;

export const labelSecondaryClasses = `
  font-arial 
  text-[16px] 
  font-normal 
  leading-[28px] 
  text-center 
  text-primary-dark
  whitespace-nowrap
`;

export const labelLinkClasses = `
  font-arial 
  text-[16px] 
  font-normal 
  leading-[28px] 
  text-center 
  text-Primary
  whitespace-nowrap
`;

export const labelDangerClasses = `
  font-arial 
  text-[16px] 
  font-normal 
  leading-[28px] 
  text-center 
  text-white
`;
export function getButtonClasses(status: DecommissionStatus): string {
  const baseClasses = [
'inline-flex', // fits to content width
    'items-center',
    'justify-center',
    'min-h-[32px]',
    'min-w-[64px]',
    'rounded-full',
    'opacity-100',
    'px-3', 
    'py-[var(--spacing-2xs)]',
    'gap-2',
    'whitespace-nowrap', 
    'max-w-full',
  ].join(' ');

  const statusStyles = {
    [DecommissionStatus.PROVISIONING]: {
      bgColor: 'bg-Foundation/Error-Light',
      borderColor: 'border-Foundation/Error-Dark',
      textColor: 'text-Foundation/Error-Dark'
    },
    [DecommissionStatus.PRE_DECOMMISSIONING]: {
      bgColor: 'bg-Foundation/Warning',
      borderColor: 'border-Foundation/Warning-Dark',
      textColor: 'border-Foundation/Warning-Dark'
    },
    [DecommissionStatus.ACTIVATED]: {
      bgColor: 'bg-primary-extra-light',
      borderColor: 'border-Primary',
      textColor: 'text-Primary'
    },
    [DecommissionStatus.DECOMMISSIONED]: {
      bgColor: 'bg-Foundation/Error-Light',
      borderColor: 'border-Foundation/Error-Dark',
      textColor: 'text-Foundation/Error-Dark'
    }
  };

  const { bgColor, borderColor, textColor } = statusStyles[status] || {
    bgColor: 'bg-primary-extra-light',
      borderColor: 'border-Primary',
      textColor: 'text-Primary'
    }
    ;

  return `${baseClasses} ${bgColor} ${borderColor} ${textColor}`;
}
export const SelectSecondaryClasses = (disabled:boolean) => `
  bg-white 
  border-2 
  border-Primary
  text-Primary 
 "w-[82px] h-[40px] rounded-md border border-[#ACACAC] bg-[#F5F5F5] opacity-100 gap-2 pt-[4px] pr-[16px] pb-[4px] pl-[16px] text-sm
  ${disabled ? 'opacity-45 cursor-not-allowed' : ''}
`;